import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const ChevronRightFilled: React.FC<IconComponentProps> = ({
  className,
}) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.4811 12.733C6.15037 13.0643 5.61332 13.0639 5.28316 12.7319C4.95458 12.4016 4.95517 11.8677 5.28448 11.5381L8.82156 7.99764L5.2852 4.46245C4.95556 4.13292 4.95479 3.59876 5.2835 3.26828C5.61352 2.93648 6.1503 2.93589 6.48106 3.26696L10.7891 7.57902C11.0201 7.81031 11.0202 8.18506 10.7893 8.41647L6.4811 12.733Z"
      fill="currentColor"
    />
  </svg>
);
